module.exports = __webpack_public_path__ + "static/alexandria-ocasiocortez-c113eac4237d8d7f4c780e68f95172fa.jpg";